import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from '../Pages/Landing/LandingPage';
import LoginPage from './LoginPage';
import RegisterPage from './RegisterPage';
import InviteLandingPage from '../Pages/Onboarding/InviteLandingPage';

/**
 * Minimal public app shell — the ONLY thing rendered for an unauthenticated
 * visitor. It deliberately mounts none of the authenticated data hooks or
 * SignalR hubs that live in <App/>, so the landing / login / register pages
 * fire ZERO authenticated API calls before login.
 *
 * Mirrors the public Routes block in App.tsx's RouteGate — keep the two in
 * sync (and with PUBLIC_PATHS in SessionGate).
 */
export default function PublicShell() {
  return (
    <Routes>
      <Route path="/welcome" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      {/* Tokenized invitation accept — the new-user entry point. Must be
          reachable while logged out (its whole purpose). DEV-1307. */}
      <Route path="/invite/:inviteCode" element={<InviteLandingPage />} />
      {/* Any other path while unauthenticated → landing. */}
      <Route path="*" element={<Navigate to="/welcome" replace />} />
    </Routes>
  );
}
